// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"846":"09bc8155","972":"b49fc8c6"}[chunkId] + ".chunk.js";
};